/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Payments_InvoiceInputs */

const en_settings_payments_invoice = /** @type {(inputs: Settings_Payments_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice`)
};

/**
* | output |
* | --- |
* | "Invoice" |
*
* @param {Settings_Payments_InvoiceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_payments_invoice = /** @type {((inputs?: Settings_Payments_InvoiceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Payments_InvoiceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_payments_invoice(inputs)
});
export { settings_payments_invoice as "settings.payments.invoice" }